import { createApp } from 'vue';
import Axios from 'axios';
import App from './App.vue';
import router from './router.js';

import './app.scss';
import '../public/assets/css/can-style.css';

const app = createApp(App);
app.config.globalProperties.$http = Axios;
app.use(router);
app.mount('#app');
